export class GameHowl extends Howl {
    protected _howlerid: number;
    public name: string;
    public buffer: AudioBuffer;

    public get id(): number {
        return this._howlerid;
    }
    
    constructor(props: IGameHowlProperties) {
        super(props);
        this.name = props.name;
    }

    play(spriteOrId?: string | number): number {
        const id = super.play(spriteOrId);
        this._howlerid = id;
        return id;
    }
}

interface IGameHowlProperties extends IHowlProperties {
    name: string;
}